module.exports = __webpack_public_path__ + "src/img/artist/work02_2.jpg?cfdc1a6fd2d50a50c3f8bc4737d38d12";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work02_2.jpg
// module id = 149
// module chunks = 0